export default {
  xs: '1 / 0.375',
  s: '1 / 0.5625',
  m: '1 / 0.618',
  l: '1 / 0.75',
  square: '1 / 1',
  portrait: '1 / 1.618',
}
